<template>
  <div class="container" style="height: 100vh ;display:flex;flex-direction:column">
    <div>
      <h4>Links</h4>
      <button
        class="add-button modal-action waves-effect waves-green btn-flat"
        @click="showLinkCreation()"
      >
        Create Link
      </button>
    </div>
    
    <div class="container card white settings" style="margin-bottom: 30px; overflow: auto;">
      <table class="striped centered">
        <thead>
          <tr>
            <th v-if="$store.loggedInUser.username=='admin'"  class="column" data-field="username">Name</th>
            <th      class="column" data-field="name"> Link-Name</th>
            <th     class="column"    data-field="instace">Instance</th>
            <th     class="column" data-field="description">Description</th>
            <th     class="column"   data-field="samInstance">Sam Quiz Instance</th>
            <th     class="column"   data-field="country">Country</th>
            <th     class="column" data-field="location">Location</th>
            <th     class="column" data-field="expirationDate">Expiration Date</th>
            <th     class="column" data-field="isHelenCares">Helen Cares Link</th>
            <th class ="linksColumn" data-field="link">Link</th>
          </tr>
        </thead>
        <tbody>
          
          <tr v-for="(link, index) in links" :key="index">
           
            <td v-if="$store.loggedInUser.username=='admin'" class="column spacing "   >{{ link.creatorName }}</td>
            <td     class="column spacing" >{{ link.name }}</td>
            <td     class="column spacing" >{{ link.instance }}</td>
            <td     class="column spacing">{{ link.description }}</td>
            <td     class="column spacing" >{{ link.samInstance }}</td>
            <td     class="column spacing">{{ link.country }}</td>
            <td     class="column spacing">{{ link.location }}</td>
            <td     class="column spacing" >{{ convertDate(link.expirationDate) }}</td>
            <td     class="column spacing">{{ link.isHelenCares }}</td>
            <td class="linksColumn">
              {{ formatLink(link.id) }}
              <button @click="copyLink(index)">Copy</button>
                <i
                class="material-icons right grey-text text-darken-1"
                @click="
                  editLink(
                    link.id,
                    link.name,
                    link.instance,
                    link.description,
                    link.samInstance,
                    link.country,
                    link.location,
                    link.expirationDate,
                    link.isHelenCares
                  )
                ">edit</i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="create-link" class="modal">
      <div class="modal-content">
        <h4 v-if="action == 'create'">Create Link</h4>
        <h4 v-if="action == 'edit'">Edit Link</h4>
        <form class="form">
          <div class="row">
            <div class="input-field col s12">
              <b> Link name: </b>
              <input id="name" type="text" required v-model="linkName" />
            </div>
            <div v-if="action == 'create'" class="input-field col s12">
              <b> Instance: </b>
              <select class="select" ref="instancePicker">
                <option value="" disabled selected>Select Instance</option>
                <option
                  v-for="(instance, index) in instances"
                  :key="index"
                  v-bind:value="instance"
                >
                  {{ instance }}
                </option>
              </select>
            </div>
            <div v-show="isQuizLink" class="input-field col s12">
              <b> Sam Quiz Instance: </b>
              <select class="select" ref="samInstancePicker"><!-- id="samInstance" v-model="samInstance"-->
                <option value="" disabled selected>Select Sam Quiz Instance</option>
                <option
                  v-for="(instance, index) in instances"
                  :key="index"
                  v-bind:value="instance"
                >
                  {{ instance }}
                </option>
              </select>
            </div>
            <div class="input-field col s12">
              <b> Description: </b
              ><input id="description" type="text" v-model="description" />
            </div>
            <div class="input-field col s6">
              <b> Country: </b>
              <select class="select1" id="country" v-model="selectedCountry" ref="country" @change="updateCities">
                <option v-if="action == 'create'" value="" disabled selected> Select Country</option> 
                <option v-for="country in countries" :value="country.name" :key="country.iso2">{{ country.name }}</option>
                <option v-if="action == 'edit'" selected>{{ country }}</option>
              </select>
            </div>
            
            <div class="input-field col s6">
              <b> Region: </b>
              <select class="select2" ref="location">
                <option v-if="action == 'create'" value="" disabled selected>
                  Select Region
                </option>
                <option v-for="state in cities" :value="state" :key="state">{{ state }}</option>
                <option v-if="action == 'edit'" selected>{{ location }}</option>
              </select>
            </div>
            <div class="input-field col s12">
              <b> Expiration Date: </b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <date-picker
                v-model="expirationDate"
                :default-value="expirationDate"
                type="datetime"
                placeholder="Select datetime"
              ></date-picker>
            </div>
            <label>
              <input type="checkbox" class="filled-in" v-model="isHelenCares"/>
              <span>Helen Cares Clinic</span>
            </label>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button @click="toggleQuizLink" class="waves-effect waves-green btn" style="margin-right: 80px">Quiz</button>
        <button
          class="modal-action modal-close waves-effect waves-green btn"
          style="margin-right: 50px"
        >
          Cancel
        </button>
        <button
          class="modal-action waves-effect waves-green btn"
          style="margin-right: 50px"
          @click="createLink(action)"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>

.container {
  width: auto;
  padding: 10px;
}
.linksColumn{
  width:25%;
  word-break:break-all;
}
.column{
 max-width:10%;
}
.column2{
 max-width:12.5%;
}
.spacing{
    word-break: break-word;
}
h4 {
  margin: 0;
  display: inline-block;
}
.add-button {
  float: right;
  margin-top: 5px;
  margin-right: 100px;
  background: teal;
  color: white;
}
#create-link {
  max-width: 600px;
  top: 3% !important;
}
.modal {
  top: 2%;
  max-height: 98%;
}
</style>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
//import countriesData from '@/assets/countries.json';
import { countriesData } from '../countries';

export default {
  name: "links",
  components:{
    DatePicker
  },
  data() {
    return {
      links: [],
      link:{},
      instances: [],
      linkName:"",
      instance:"",
      samInstance:"",
      isQuizLink:false,
      description:"",
      location:"",
      expirationDate:"",
      isHelenCares:false,
      linkid:"",
      action:"",
      postToStatisticsBackend:false,
      states:[
              "Stockholm",
              "Västerbotten",
              "Norrbotten",
              "Uppsala",
              "Södermanland",
              "Östergötland",
              "Jönköping",
              "Kronoberg",
              "Kalmar",
              "Gotland",
              "Blekinge",
              "Skåne",
              "Halland",
              "Västra",
              "Götaland",
              "Värmland",
              "Örebro",
              "Västmanland",
              "Dalarna",
              "Gävleborg",
              "Västernorrland",
              "Jämtland",
              ],
      selectedCountry: '',
      selectedCity: '',
      countries: countriesData,
      cities: [],
      country:"",
    }
  },
  mounted() {
      this.$el.querySelectorAll(".modal").forEach(e => M.Modal.init(e, {}));
      this.$http.get("dialogs?tag=start").then((r) => {
      if (r.data) {
        r.data.forEach((instance) => {
          if (instance.tags)
            for (let i = 0; i < instance.tags.length; i++) {
              if (instance.tags[i].includes("start_")) {
                this.instances.push(instance.tags[i]);
                break;
              }
            }
        });
      }
    });
    this.getLinks();
  },
  updated() {
    if (this.$el != null) {
      const selector = this.$el.querySelector("select");
      if (selector) {
        M.FormSelect.init(selector, {});
      }
      const selector1 = this.$el.querySelector(".select1");
      if (selector1) {
        M.FormSelect.init(selector1, {});
      }
      const selector2 = this.$el.querySelector(".select2");
      if (selector1) {
        M.FormSelect.init(selector2, {});
      }
    }
  },
  methods: {
    updateCities() {
      const selectedCountryData = this.countries.find(country => country.name === this.selectedCountry);
      if (selectedCountryData) {
        this.cities = selectedCountryData.states.map(state => state.name);
      } else {
        this.cities = [];
      }
    },
    toggleQuizLink(){
      this.isQuizLink = !this.isQuizLink;
      console.log(this.isQuizLink);
    },
    createLink(action) {
        if( this.linkName == ""){
           M.toast({html:"Enter link name","classes":"red"}); 
           return
        }
        else if( this.description == ""){
          M.toast({html:"Enter description","classes":"red"});
          return
        }
        else if(this.$refs.samInstancePicker.value == "" && this.isQuizLink){
          M.toast({html:"Please select Sam Quiz Instance","classes":"red"});
          return;
        }
        else if( this.$refs.country.value == ""){
           M.toast({html:"Please select country","classes":"red"});
           return
        }
        else if( this.$refs.location.value == ""){
           M.toast({html:"Please select location","classes":"red"});
           return
        }
        else if(this.expirationDate == undefined || this.expirationDate == ""){
            M.toast({html:"Please enter expiration date","classes":"red"});
            return
        }
        
        if(action == "create"){
          if( this.$refs.instancePicker.value == ""){
           M.toast({html:"Please select instance","classes":"red"});
           return
          }
            var date = JSON.stringify(this.expirationDate);
            date = date.slice(1, -1);
            this.link.name = this.linkName;
            this.link.description = this.description;
            this.link.samInstance = this.$refs.samInstancePicker.value;
            this.link.country = this.$refs.country.value;
            this.link.location = this.$refs.location.value;
            this.link.instance = this.$refs.instancePicker.value;
            this.link.expirationDate = date;
            this.link.isHelenCares = this.isHelenCares;
            this.postLink(this.link).then((response) => {
              this.getLinks();
              M.Modal.getInstance(this.$el.querySelector("#create-link")).close();
            });
        }
        if(action == "edit"){

            var date = JSON.stringify(this.expirationDate);
            date = date.slice(1, -1);
            this.link.id=this.linkid;
            this.link.name = this.linkName
            this.link.description = this.description
            this.link.samInstance = this.$refs.samInstancePicker.value
            this.link.country = this.$refs.country.value;
            this.link.location = this.$refs.location.value
            this.link.instance = this.instance
            this.link.expirationDate = date
            this.link.isHelenCares = this.isHelenCares
            this.putLink(this.link.id,this.link).then((response) => {
              this.getLinks();
                M.Modal.getInstance(this.$el.querySelector("#create-link")).close();
              })
        }
    },
    editLink(id,name,instance,description,samInstance,country,location,expirationDate, isHelenCares) {
      this.linkid = id;
      this.action="edit";
      this.linkName=name;
      this.samInstance=samInstance;
      this.instance=instance;
      this.description=description;
      this.$refs.location.value=location;
      this.location = location;
      this.$refs.country.value=country;
      this.country = country;
      this.selectedCountry = country;
      this.selectedCity = location;
      this.expirationDate=new Date(expirationDate);
      this.isHelenCares = isHelenCares;
      if (samInstance == "") {
        this.isQuizLink = false;
      } else {
        this.isQuizLink = true;
      }
      M.Modal.getInstance(this.$el.querySelector("#create-link")).open();
    },
    formatLinkByIndex(i) {
        return this.formatLink(this.links[i].id);
    },
    formatLink(id){
      return "https://helen-on-web-dot-offshore-235606.el.r.appspot.com/configure/"+id;
    },
    copyLink(i) {
        navigator.clipboard.writeText(this.formatLinkByIndex(i));
    },
    showLinkCreation(){
      this.action="create";
      this.linkName = "";
      this.description = "";
      this.samInstance = "";
      this.$refs.country.value = "";
      this.$refs.location.value = "";
      this.link.expirationDate = "";
      this.isQuizLink = false;
      this.isHelenCares = false;
      M.Modal.getInstance(this.$el.querySelector("#create-link")).open();
    },
    getLinks() {
      return new Promise((resolve, reject) => {
          this.$http
              .get('/auth/links')
              .then(r => {
                  this.links = r.data
                  console.log(this.links.find(e => e.name == "test_helen_cares_multiple_clinics"))
                  
                  this.links.sort(function(a, b) { 
                    var d1 = new Date(a.created)
                    var d2 = new Date(b.created) 
                    return d2.getTime() - d1.getTime();
                  });
                  if(this.$store.loggedInUser.username!='admin'){
                     this.filterLinksByUser();
                  }

                  if (this.postToStatisticsBackend) {
                    this.postNewLinkToStatisticssBackend(this.links[0]);
                    if (this.isQuizLink) {
                      this.postNewLinkToUsersBackend(this.links[0])
                    }
                    this.postToStatisticsBackend = false;
                  }
                  if(this.$store.loggedInUser.username=='admin'){
                    try {
                      this.addLinkCreatorName();
                    } catch(e){}
                  }
                  resolve(this.links)
              })
              .catch(r => {
                  reject(r)
              })
      })
    },
    addLinkCreatorName(){
      for(const i in this.links){
        const user = this.$store.users.filter(l => l.id==this.links[i].creator);
        this.links[i].creatorName = user[0].username;
      }
    },
    filterLinksByUser(){
      this.links=this.links.filter(l => l.creator==this.$store.loggedInUser.id);
    },
    postLink(link) {
      return new Promise((resolve, reject) => {
          this.$http.post('/auth/links',link).then(
            response =>{
              if(response.status == 200){
                M.toast({html:"Link Created","classes":"green"});
                this.links.push(link);
                this.postToStatisticsBackend = true;
              }else{
                M.toast({"html":"Error"+response.data,"classes":"red"});
              }               
              resolve(response);
            }
          );
      });
    },
    putLink(id,link) {
        return new Promise((resolve, reject) => {
            this.$http.put('/auth/links/'+id, link).then(
              response =>{
                if(response.status == 200){
                  M.toast({html:"Changes saved","classes":"green"});
                  this.links.push(link);
                }else{
                  M.toast({"html":"Error"+response.data,"classes":"red"});
                }               
                resolve(response);
              }
            );
        });
    },
    convertDate(value){
      return moment.utc(value).format('LLLL');
    },
    postNewLinkToStatisticssBackend(link) {
      let s = {
        "clinicInfo": {
          "clinicName":link.name,
          "region":link.location,
          "link":this.formatLink(link.id),
          "clinicId":link.id,
        }
      }
      axios.post('https://hsm-p.se-local-server-helen.com/api/hsm/webui-cl-info',s);
    },
    postNewLinkToUsersBackend(link) {
      let s = {
        "instance":link.instance,
        "samInstance":link.samInstance,
        "link":link.id,
        "clinicId":link.id,
        "clinicName":link.name
      }
      axios.post('https://se-local-server-helen.com/api/userrecord/webui/link',s);
    }
  },
};
</script>